import React from 'react';
import {motion} from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import ShareButton from './ShareButton';
import * as FiIcons from 'react-icons/fi';

const {FiAlertTriangle,FiNavigation,FiWind,FiMapPin,FiClock}=FiIcons;

const TyphoonCard=({data})=> {
  if (!data) return null;

  const getSignalColor=(signal)=> {
    switch (signal) {
      case '1': return 'bg-yellow-100 border-yellow-300 text-yellow-800';
      case '2': return 'bg-orange-100 border-orange-300 text-orange-800';
      case '3': return 'bg-red-100 border-red-300 text-red-800';
      case '4': return 'bg-purple-100 border-purple-300 text-purple-800';
      case '5': return 'bg-gray-900 border-gray-700 text-white';
      default: return 'bg-gray-100 border-gray-300 text-gray-800';
    }
  };

  return (
    <motion.div
      initial={{opacity: 0,scale: 0.95}}
      animate={{opacity: 1,scale: 1}}
      transition={{delay: 0.2}}
      className="bg-gradient-to-r from-red-50 to-orange-50 rounded-2xl shadow-xl p-7 border border-red-200"
    >
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6 mb-6">
        <div className="flex items-center">
          <div className="p-3 bg-red-100 rounded-xl mr-4">
            <SafeIcon icon={FiAlertTriangle} className="text-3xl text-red-600" />
          </div>
          <div>
            <h2 className="text-2xl font-bold text-red-900">
              Typhoon "{data.localName}" {data.internationalName && `(${data.internationalName})`}
            </h2>
            <p className="text-red-700 mt-1">
              {data.category} • {data.status}
            </p>
          </div>
        </div>

        <ShareButton 
          weatherData={null} 
          typhoonData={data} 
          location="Northern Mindanao" 
          size="default" 
          className="bg-red-600 hover:bg-red-700" 
        />
      </div>

      <div className="grid md:grid-cols-2 gap-8">
        <div className="space-y-4">
          <div className="flex items-center text-base">
            <SafeIcon icon={FiClock} className="mr-3 text-gray-600 text-lg" />
            <span className="font-medium">Issue Time:</span>
            <span className="ml-2">{data.issueTime}</span>
          </div>
          <div className="flex items-center text-base">
            <SafeIcon icon={FiMapPin} className="mr-3 text-gray-600 text-lg" />
            <span className="font-medium">Position:</span>
            <span className="ml-2">{data.position}</span>
          </div>
          <div className="flex items-center text-base">
            <SafeIcon icon={FiWind} className="mr-3 text-gray-600 text-lg" />
            <span className="font-medium">Winds:</span>
            <span className="ml-2">{data.maxWinds} kph,gusts {data.gusts} kph</span>
          </div>
          <div className="flex items-center text-base">
            <SafeIcon icon={FiNavigation} className="mr-3 text-gray-600 text-lg" />
            <span className="font-medium">Movement:</span>
            <span className="ml-2">{data.movement}</span>
          </div>
        </div>

        <div>
          <h3 className="font-semibold text-lg mb-3">Track Forecast:</h3>
          <p className="text-gray-700 mb-4">{data.forecast}</p>
          {data.landfall && (
            <div className="bg-red-100 border border-red-300 rounded-xl p-4">
              <p className="text-red-800 font-medium">
                <strong>Landfall Window:</strong> {data.landfall}
              </p>
            </div>
          )}
        </div>
      </div>

      {data.signals && data.signals.length > 0 && (
        <div className="mt-7">
          <h3 className="font-semibold text-lg mb-3">PSWS Signals:</h3>
          <div className="grid gap-3">
            {data.signals.map((signal,index)=> (
              <div 
                key={index} 
                className={`p-4 rounded-xl border text-base ${getSignalColor(signal.level)}`}
              >
                <strong>Signal #{signal.level}:</strong> {signal.areas}
              </div>
            ))}
          </div>
        </div>
      )}

      {data.risks && data.risks.length > 0 && (
        <div className="mt-7">
          <h3 className="font-semibold text-lg mb-3">Risks & Warnings:</h3>
          <ul className="space-y-2">
            {data.risks.map((risk,index)=> (
              <li key={index} className="flex items-start">
                <span className="text-red-600 mr-2 mt-1">•</span>
                <span>{risk}</span>
              </li>
            ))}
          </ul>
        </div>
      )}

      <div className="mt-7 p-5 bg-orange-100 border border-orange-300 rounded-xl">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div>
            <p className="text-orange-800 font-medium text-lg">
              🚨 Share this alert with family and neighbors!
            </p>
            <p className="text-orange-700 mt-1">
              Help spread critical typhoon information to keep your community safe.
            </p>
          </div>
          <ShareButton 
            weatherData={null} 
            typhoonData={data} 
            location="Northern Mindanao" 
            size="default" 
            className="bg-orange-600 hover:bg-orange-700" 
          />
        </div>
      </div>
    </motion.div>
  );
};

export default TyphoonCard;